function initAccordionTabs(section) {
  const tabs = section.querySelectorAll('.accordion-tabs__tab');
  const panels = section.querySelectorAll('.accordion-tabs__panel');
 
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const index = tab.dataset.tabIndex;
 
      tabs.forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach((p) => p.classList.remove('is-active'));
 
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
 
      const panel = section.querySelector(`.accordion-tabs__panel[data-panel-index="${index}"]`);
      if (panel) panel.classList.add('is-active');
    });
  });
 
  section.querySelectorAll('.accordion__button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });
}
 
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-section-type="accordion-tabs"]').forEach(initAccordionTabs);
});
 
 